import { Category, CategoryQuestion } from '@/types';
import http from '@/js/http';

export default {
    async get(id: string) {
        const { data } = await http.get<Category>(`/categories/${id}`);
        return data;
    },

    // all: api('/api/categories', 'get'),

    // create: api('/api/categories', 'post'),

    // update: api('/api/categories/{categoryId}', 'put'),

    // delete: api('/api/categories/{categoryId}', 'delete'),

    async questions(categoryId: string | number) {
        const { data } = await http.get<CategoryQuestion[]>(`/categories/${categoryId}/questions`);
        return data;
    },
};
